// extracted by mini-css-extract-plugin
module.exports = {"dispensary-header__logo":"DispensaryHeaderSlim_dispensary-header__logo__f2Q7S","dispensary-follow_button":"DispensaryHeaderSlim_dispensary-follow_button__LvYsd"};